import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Compass } from "lucide-react";
import NavTop from "@/components/nav/nav_top";
import ButtonMain from "@/components/buttons/button_main";
import ButtonGhost from "@/components/buttons/button_ghost";

export default function NotFoundPage() {
  const navigate = useNavigate();
  return (
    <div className="flex min-h-screen flex-col bg-slate-50/70">
      <NavTop />
      <main className="flex flex-1 items-center justify-center px-4">
        <motion.div initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} className="text-center">
          <span className="mx-auto flex h-16 w-16 items-center justify-center rounded-3xl bg-brand-tint text-brand-lime">
            <Compass size={30} />
          </span>
          <h1 className="mt-6 text-5xl font-extrabold tracking-tight text-brand-ink">404</h1>
          <p className="mt-2 text-lg font-bold text-brand-ink">This page moved out</p>
          <p className="mt-1 text-sm font-semibold text-slate-500">The address you are looking for is not listed. Let us get you home.</p>
          <div className="mt-6 flex justify-center gap-3">
            <ButtonMain onClick={() => navigate("/")}>Back home</ButtonMain>
            <ButtonGhost onClick={() => navigate("/swipe")}>Start swiping</ButtonGhost>
          </div>
        </motion.div>
      </main>
    </div>
  );
}
